export const formatPath = (value: string) => {
    if (!value) return ['']

    // Check if the value contains attributes (dots followed by word characters)
    const regex = /^(.+?)((\.[\w]+)+)$/
    const match = value?.match(regex)

    // If there are attributes, return the path part before the attributes
    if (match) {
        return [match[1]]
    }

    // If there are no attributes, return the entire value as the path
    return [value]
}
